// extracted by mini-css-extract-plugin
module.exports = {"tasks":"tasks___3U7Ci","task-data-modal":"task-data-modal___1i2da"};